<script setup lang="ts">
    import { cn } from '@/lib/utils';
    import { computed, ref } from 'vue';
    import axios from 'axios';
    import Icon from '@/components/Icon.vue';
    import type { HTMLAttributes } from 'vue';
    import VueDatePicker from '@vuepic/vue-datepicker';

    const props = defineProps<{
        modelValue: string;
        class?: HTMLAttributes['class'];
    }>();

    const emit = defineEmits<{
        'update:modelValue': [value: string];
    }>();

    const date = ref({
        month: new Date(props.modelValue).getMonth(),
        year: new Date(props.modelValue).getFullYear(),
    });

    const month = computed(() => {
        return new Date(date.value.year, date.value.month).toLocaleString('da', {
            month: 'short',
        });
    });

    const handleDateUpdate = async (newDate: { month: number; year: number }) => {
        const formattedDate = `${newDate.year}-${String(newDate.month + 1).padStart(2, '0')}`;
        await axios.patch(route('v2.user.select-month'), {
            selected_month: formattedDate,
        });
        emit('update:modelValue', formattedDate);
    };
</script>

<template>
    <VueDatePicker
        v-model="date"
        @update:model-value="handleDateUpdate"
        month-picker
        auto-apply
        :teleport="true"
        :action-row="{ showSelect: false, showCancel: false }"
        locale="da"
        :config="{
            modeHeight: 200,
        }"
        :transitions="{
            menuAppearBottom: 'dp-menu-appear',
        }"
    >
        <template #trigger>
            <div
                :class="cn('hover:text-accent flex cursor-pointer items-center gap-2', props.class)"
            >
                <span class="text-xs uppercase">{{ month }}</span>
                <Icon
                    name="calendar"
                    class="size-4"
                />
            </div>
        </template>
    </VueDatePicker>
</template>
